<div class="layout-ParentDiv innerDiv">
  <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
     <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Address Log - <span>{{username | titlecase}} </span>
                    <span>({{mobileNumber}})</span>
                    <span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn">
                    <span>
                        <img src="../../../assets/images/backend-image/header/exportIcon.svg" alt="">
                    </span> Export
                </button> -->
            </div>
        </div>
        <div class="mainDivBody">
            <div class="maintableDiv">
                 <div class="tableParanet">
                       <p-table class="p2-table-columns show-columns" #dt [value]="userlist"
                [lazy]="true" (onLazyLoad)="loadUserAddressLog($event)" [totalRecords]="totalRecords" [loading]="loading"
                styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th   class="countryNameTd">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Country Name
                              
                            </div>
                        </th>
                        <th class="stateNameTd">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                State Name
                                
                            </div>
                        </th>
                        <th  class="cityNameTd">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                City Name
                              
                            </div>
                        </th>
                        <th class="addressTd">
                            <div class="p-d-flex p-jc-between p-ai-center">
                              Address
                                
                            </div>
                        </th>
                        <th  class="zipCodeTd">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Zip Code
                                
                            </div>
                        </th>
                        <th  class="created_atTD">
                            <div class="p-d-flex p-jc-between p-ai-center">
                               Created At  
                            </div>
                        </th>
                       
                    </tr>
                    <tr>
                        <th class="countryNameTd">
                           <input type="text">
                        </th>
                        <th class="stateNameTd">
                              <input type="text">
                        </th>
                        <th  class="cityNameTd">
                                <input type="text">
                        </th>
                        <th class="addressTd">
                               <input type="text">
                        </th>
                        <th  class="zipCodeTd">
                              <input type="text">
                        </th>
                        <th  class="created_atTD">
                               <input type="text">
                        </th>
                       
                    </tr>
                   
                </ng-template>
                <ng-template pTemplate="body" let-userlist>
                    <tr class="p-selectable-row">
                        <td class="countryNameTd">
                            {{userlist.countryname}}
                        </td>
                        <td class="stateNameTd">
                            {{userlist.statename}}
                        </td>
                        <td class="cityNameTd">
                            {{userlist.cityname}}
                        </td>
                        <td class="addressTd">
                            {{userlist.address}}
                        </td>

                        <td class="zipCodeTd">
                            {{userlist.zipcode}}
                        </td>

                        <td class="created_atTD">
                            {{userlist.created_at  | date:'dd/MM/yyyy'}}
                        </td>
                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">No User Address.</td>
                    </tr>
                </ng-template> 
            </p-table>

                 </div>
            </div>
        </div>

    </div>
</div> 